export default "__VITE_ASSET__CB4sZ8Ve__"